import * as hf from './_hf';
import * as ht from './_ht';
import * as f from './_cmFTH';

export const load_31rLsAsync = async () => {
  const _cdn = f.vdd();
  const _ls = await f.loadLsAsync({
    tgt: '_31rs',
    cdn: _cdn,
  });
  return _ls;
};

export const load_31rDzAsync = async (pz: {
//  _dmn?: ht.n,
  _31r_fst?: ht.n,
  _31r_icn?: ht.n,
}) => {
//  let _cdn = '';
//  _cdn += (pz._dmn) ? (f.vdd(true, false) + ` AND _dmn = ${pz._dmn}`) : f.vdd();
  let _cdn = f.vdd();
  if (pz._31r_fst) _cdn += ` AND _fst = ${pz._31r_fst}`; 
//  if (pz._31r_icn) _cdn += ` AND _icn = '${pz._31r_icn}'`; 
  if (pz._31r_icn) _cdn += ` AND _icn::NUMERIC::INTEGER = ${pz._31r_icn}`; 
  //hf.l(`_cv_31___Mz 21: ${_cdn}`);
  const _dz = await f.loadDzAsync({
    tgt: '_31rs',
    cdn: _cdn,
  });
  return {
    _31rz: _dz
  };
};
